export type Brand = 'apex' | 'imperium'

const OVERRIDE_KEY = 'brand_override'

// Zachytit ?brand= hned při načtení bundle — router při redirectu na /login
// query string zahodí. Override drží sessionStorage (jen pro UAT/localhost test).
const queryBrand = new URLSearchParams(window.location.search).get('brand')
if (queryBrand === 'apex' || queryBrand === 'imperium') {
  sessionStorage.setItem(OVERRIDE_KEY, queryBrand)
}

// Login je pre-auth — teritorium nelze vzít z API, určuje se z hostname.
// app.apexcapital.cz -> apex, app.imperium-finance.cz -> imperium.
export const getBrand = (): Brand => {
  const override = sessionStorage.getItem(OVERRIDE_KEY)
  if (override === 'apex' || override === 'imperium') {
    return override
  }
  return window.location.hostname.includes('imperium') ? 'imperium' : 'apex'
}
